webpackJsonp([240543100269747],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/shop.json":
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"markdownRemark": {
				"frontmatter": {
					"title": "Shop "
				}
			}
		},
		"pathContext": {
			"path": "/shop"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---shop-d105bcf09871b4cff37e.js